/**
 * DowngradeImmediateConfirmModal
 * 
 * Modal de confirmação para downgrade imediato Premium → Basic (Caso B)
 * Informa ao usuário que perderá features Premium imediatamente
 * 
 * Criado em: 06/02/2026
 */

import { AlertCircle, X } from 'lucide-react';

interface DowngradeImmediateConfirmModalProps {
  currentPlan: string;
  targetPlan: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DowngradeImmediateConfirmModal({
  currentPlan,
  targetPlan,
  onConfirm,
  onCancel
}: DowngradeImmediateConfirmModalProps) {
  const planLabels: Record<string, string> = {
    premium: 'Premium',
    basic: 'Básico',
    free: 'Gratuito'
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full relative">
        {/* Botão fechar */}
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Ícone de alerta */}
        <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full mx-auto mb-4">
          <AlertCircle className="w-6 h-6 text-orange-600" />
        </div>

        {/* Título */}
        <h3 className="text-xl font-bold text-center mb-2">
          Downgrade imediato para {planLabels[targetPlan] || targetPlan}
        </h3>

        {/* Mensagem principal */}
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-4">
          <p className="text-sm text-orange-900 font-medium mb-2">
            ⚠️ Atenção: A troca entrará em vigor imediatamente
          </p>
          <p className="text-sm text-orange-800">
            Você perderá as features remanescentes do plano {planLabels[currentPlan]} a partir de agora e passará a ter acesso apenas às funcionalidades do plano {planLabels[targetPlan]}.
          </p>
        </div>

        {/* Informação adicional */}
        <p className="text-sm text-gray-600 text-center mb-6">
          Se você não deseja perder as features agora, cancele esta ação.
        </p>

        {/* Botões de ação */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-all"
          >
            Cancelar
          </button>
          
          <button
            onClick={onConfirm}
            className="flex-1 py-3 bg-orange-600 text-white rounded-xl font-semibold hover:bg-orange-700 transition-all"
          >
            Trocar agora
          </button>
        </div>
      </div>
    </div>
  );
}
